export default __webpack_public_path__ + "static/media/IBM.3cbadd59.PNG";